<div class="chat-input-container">
  @if (attachments.pending().length) {
    <div class="attachments" aria-label="Files for this message">
      @for (file of attachments.pending(); track file.id) {
        <app-chat-attachment-tile [file]="file" [removable]="true" />
      }
    </div>
  }
  <textarea
    #messageInput
    cdkTextareaAutosize
    cdkAutosizeMinRows="1"
    cdkAutosizeMaxRows="13"
    maxlength="25000"
    [placeholder]="conversation.isOverview() ? 'Start a new chat...' : 'Ask / do anything'"
    [disabled]="conversation.loading() || !conversation.selectedExpert()"
    [(ngModel)]="messageText"
    (focus)="focusChange.emit(true)"
    (blur)="focusChange.emit(false)"
    (keydown.enter)="onEnter($event)"></textarea>

  <div class="chat-input-footer">
    <div class="chat-input-footer-start">
      <input
        #fileInput
        class="file-input"
        type="file"
        multiple
        (change)="onFilesSelected($event)" />
      <button
        cuiButton
        square
        size="small"
        variant="plain"
        surface="muted"
        type="button"
        aria-label="Attach files"
        [disabled]="fileDisabled()"
        (click)="chooseFiles()">
        <span class="material-symbols-outlined" aria-hidden="true">attach_file</span>
      </button>
    </div>
    <div class="chat-input-footer-end">
      <ng-content select="[chatInputEnd]" />
      @if (conversation.isRunPending()) {
        <button
          cuiButton
          square
          size="small"
          variant="primary"
          type="button"
          [attr.aria-label]="conversation.cancelling() ? 'Stopping response' : 'Stop response'"
          [disabled]="conversation.cancelling()"
          (click)="conversation.cancelRun()"
          matTooltip="Stop response">
          <span class="material-symbols-outlined" aria-hidden="true">stop</span>
        </button>
      } @else {
        <button
          cuiButton
          square
          size="small"
          variant="primary"
          type="button"
          [attr.aria-label]="attachments.uploading() ? 'Uploading files' : 'Send message'"
          [disabled]="
            !conversation.canSend() || (!messageText().trim() && !attachments.pending().length)
          "
          [loading]="attachments.uploading()"
          (click)="emitSend()"
          matTooltip="Send"
          [matTooltipDisabled]="attachments.uploading()">
          <span class="material-symbols-outlined" aria-hidden="true">arrow_upward</span>
        </button>
      }
    </div>
  </div>
</div>
